import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.UserList.PermissionsCell', {
    permissionsCount: '{count} permissions',
    onePermission: '1 permission',
});
